/** Client-side guardrails; backend must re-validate uploads. */
export const TEAM_CHAT_MAX_FILE_BYTES = 150_000;
export const TEAM_CHAT_ALLOWED_MIME = new Set([
  'image/png',
  'image/jpeg',
  'image/webp',
  'image/gif',
  'application/pdf',
  'text/plain',
  'text/csv',
  'application/json',
  'text/json',
]);

export function validateTeamChatFile(file: File): { ok: true } | { ok: false; reason: string } {
  if (file.size > TEAM_CHAT_MAX_FILE_BYTES) {
    return { ok: false, reason: `File exceeds ${TEAM_CHAT_MAX_FILE_BYTES} bytes (demo limit).` };
  }
  if (!TEAM_CHAT_ALLOWED_MIME.has(file.type)) {
    return { ok: false, reason: 'Unsupported file type for this build.' };
  }
  return { ok: true };
}

export function readFileAsDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(String(r.result || ''));
    r.onerror = () => reject(new Error('read_failed'));
    r.readAsDataURL(file);
  });
}
